import { ITab } from './tab';

/**
 * Add any new tab items into this array
 */
const TABS = [
    { label: 'Agents', index: 'agents' },
    { label: 'Assignment', index: 'assignment' },
    { label: 'Attributes', index: 'attributes' },
    { label: 'Business Units', index: 'business-units' },
    { label: 'Channel Type', index: 'channeltype' },
    { label: 'Completion Codes', index: 'dispositioncodes' },
    { label: 'Conversations', index: 'conversations' },
    { label: 'Customer Details', index: 'customer-details' },
    { label: 'End Customers', index: 'customers' },
    { label: 'External Directory', index: 'directory' },
    { label: 'History', index: 'history' },
    { label: 'Internal Directory', index: 'internal' },
    { label: 'IVRs', index: 'ivr' },
    { label: 'Performance', index: 'performance' },
    { label: 'Profile', index: 'profile' },
    { label: 'Queues', index: 'queues' },
    { label: 'Tasks', index: 'tasks' },
    { label: 'Teams', index: 'teams' },
    { label: 'Thresholds', index: 'thresholds' },
    { label: 'Utilisation', index: 'utilisation' },
    { label: 'Work Groups', index: 'work-groups' },
] as const;

export type TabItemKeys = (typeof TABS)[number]['index'];

export type TabKeys = {
    [Property in (typeof TABS)[number]['index'] as `${Uppercase<Property>}`]: Property;
};

export const TAB_KEYS: TabKeys = TABS.reduce(
    (acc, cur) => ({
        ...acc,
        [cur.index.toUpperCase()]: cur.index,
    }),
    {} as any,
);

export class TabItems {
    static getItems<T extends string[]>(keys: T): ITab[] {
        return TABS.filter((tab: ITab) => keys.includes(tab.index));
    }

    static getItem<T>(key: T): ITab {
        const selectedTab = TABS.find(tab => tab.index === key);

        if (!selectedTab) {
            throw new Error(
                'This tab can not be found in the list of TABS - it has either been removed or the key is incorrect',
            );
        }

        return selectedTab;
    }
}

export type EmailDirectoryTabKeys = Extract<
    TabItemKeys,
    'directory' | 'customers' | 'internal'
>;
